import makeStyles from '@mui/styles/makeStyles'

const useAddMacidStyles = makeStyles({
  root: {
    '& MuiPickersDay-daySelected': {
      backgroundColor: 'white',
      boxShadow: '4px 4px 15px rgba(0, 0, 0, 0.05)',
      borderRadius: '50px',
      border: 'none',
      '&:hover': {
        backgroundColor: 'white',
        border: 'none',
      },
    },
    '& .MuiInputBase-root': {
      color: '#000',
      backgroundColor: 'transparent',
      borderRadius: '50px',
      border: 'none',
    },
  },
  icon: {
    marginLeft: 0,
    marginRight: 8,
  },
})

export default useAddMacidStyles
